<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md"
        defaultHref="/settings/pos-settings/discounts"
      ></ion-back-button>
    </ion-buttons>
    <smr-stylist-picker
      cssClass="sm-stylist-picker-for-stylist-discounts"
      *ngIf="stylist"
      [stylistID]="stylist.getID()"
      [readOnly]="readOnlyStylistPicker"
      [disabled]="isLoading"
      (onInit)="onStylistPickerInit($event)"
      (stylistSelect)="onStylistSelect($event)"
    ></smr-stylist-picker>
    <ion-buttons slot="end">
      <ion-button (click)="createDiscount()">
        <ion-icon name="add"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask>

  <salonmonster-tap-retry *ngIf="errorOccuredWhileLoadingDiscounts" (click)="loadDiscounts(stylist)"></salonmonster-tap-retry>

  <ng-container *ngIf="!isLoading && !errorOccuredWhileLoadingDiscounts">

    <ion-row>
      <ion-col class="hidden-sm-down"></ion-col>

      <ion-col size="12" size-sm="12" size-md="8" size-lg="8" size-xl="8">
        <ion-item *ngIf='discounts.count() == 0'>
          <div class="no-discounts">No discounts</div>
        </ion-item>

        <ion-list *ngIf='discounts.count() > 0'>
          <ion-item
            class="discount"
            *ngFor="let discount of discounts; let discountIndex = index;"
            (click)="onDiscountEditHandler(discount, discountIndex)">
            {{ discount.name }}
            <div slot="end">
              {{ discount.amount }} {{ discount.type == 1 ? '%' : '$'}}
            </div>
          </ion-item>
        </ion-list>
      </ion-col>

      <ion-col class="hidden-sm-down"></ion-col>
    </ion-row>
  </ng-container>
</ion-content>
